import React from "react";
import { Button } from "@/components/ui/button";
import { Save } from "lucide-react";

export function OrderBottomBar({
  selectedCount,
  totalQty,
  totalOm,
  totalStima,
  marginEur,
  marginPct,
  showMargin = false,
  scontoCanale,
  saving,
  editingOrderId,
  onSave,
}) {
  const marginColor = marginPct >= 30 ? "text-emerald-400"
                    : marginPct >= 15 ? "text-amber-300"
                    : "text-red-400";
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-[#0f0f11] border-t border-white/10 p-3 flex items-center gap-3" data-testid="order-bar">
      <div className="flex-1 min-w-0">
        <div className="flex items-baseline gap-2 flex-wrap">
          <span className="text-white text-sm font-bold">{selectedCount} prodotti</span>
          <span
            className="text-amber-300 text-base font-mono font-bold"
            data-testid="order-stima-total"
            title="Stima approssimativa (sc1/2/3/4 calcolati al salvataggio)"
          >
            ~{totalStima.toLocaleString("it-IT", { style: "currency", currency: "EUR" })}
          </span>
          {showMargin && totalStima > 0 && (
            <span
              className={`text-xs font-mono font-bold ${marginColor}`}
              data-testid="order-margin-live"
              title={`Margine stimato in tempo reale (Ricavi - Costo). Si aggiorna ad ogni modifica e viene 'fissato' al momento della creazione del BBB.`}
            >
              Marg. {marginPct.toFixed(1)}% ({marginEur.toLocaleString("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 })})
            </span>
          )}
        </div>
        <span className="text-zinc-500 text-[10px] block">
          {totalQty} vnd
          {totalOm > 0 && (
            <span className="text-fuchsia-400 ml-1">+ {totalOm} om.</span>
          )}
          {Number(scontoCanale) > 0 && (
            <span className="text-violet-400 ml-1">· sc. canale {scontoCanale}%</span>
          )}
        </span>
      </div>
      <Button onClick={onSave} disabled={saving}
        className="bg-emerald-500 hover:bg-emerald-600 text-white font-medium px-6"
        data-testid="save-quick-order">
        <Save className="w-4 h-4 mr-2" />
        {saving ? "Salvataggio..." : editingOrderId ? "Aggiorna Ordine" : "Crea Ordine"}
      </Button>
    </div>
  );
}
